import * as serviceV2 from './resource-allocation.service.v2';

const useResourceAllocationService = () => {
  return serviceV2;
};

export default useResourceAllocationService;
